import {
  NavigateOptions,
  To,
  useNavigate,
  useNavigation,
  useParams,
  useRouteLoaderData,
} from 'react-router-dom'
import {PlantView} from './PlantView'
import React, {useState} from 'react'
import {App, Modal} from 'antd'
import {useMousePositionContext} from './usePlantModalMousePosition'
import {PlantRouteLoaderData} from '../App'
import {ExclamationCircleFilled} from '@ant-design/icons'
import {useIntl} from 'react-intl'
import './plantForm.less'

export type PlantModalProps = {
  routeWhenClosed: string
}

export function PlantModal({routeWhenClosed}: PlantModalProps) {
  const navigation = useNavigation()
  const navigate = useNavigate()
  const routeParams = useParams()
  const {mousePosition} = useMousePositionContext()
  const intl = useIntl()
  const app = App.useApp()

  const navigateDelayed = (to: To, options?: NavigateOptions) =>
    setTimeout(() => {
      navigate(to, options)
    }, 0)

  const plantPopupVisible = Boolean(routeParams.plantId)
  const plantLoading = plantPopupVisible && navigation.state === 'loading'
  const plantRouteLoaderData = useRouteLoaderData('plant') as PlantRouteLoaderData | undefined
  const projectPlantRouteLoaderData = useRouteLoaderData('projectWithPlant') as
    | PlantRouteLoaderData
    | undefined
  const toDoPlantRouteLoaderData = useRouteLoaderData('toDoWithPlant') as
    | PlantRouteLoaderData
    | undefined
  const journalEventPlantRouteLoaderData = useRouteLoaderData('journalRecordWithPlant') as
    | PlantRouteLoaderData
    | undefined

  const routeData: PlantRouteLoaderData = plantRouteLoaderData ||
    projectPlantRouteLoaderData ||
    toDoPlantRouteLoaderData ||
    journalEventPlantRouteLoaderData || {type: 'newPlant'}

  const [closePreventedReason, setClosePreventedReason] = useState<string | null>(null)

  const onClose = () => {
    if (closePreventedReason) {
      app.modal.confirm({
        title: intl.formatMessage({id: 'confirmFormCloseTitle'}),
        icon: <ExclamationCircleFilled />,
        content: closePreventedReason,
        onOk() {
          navigateDelayed(routeWhenClosed)
        },
        onCancel() {},
      })
    } else {
      navigateDelayed(routeWhenClosed)
    }
  }

  return (
    <Modal
      className="plant-modal"
      open={plantPopupVisible}
      onCancel={onClose}
      mousePosition={mousePosition || undefined}
      footer={null}
      destroyOnHidden
      width={1200}
    >
      {routeData.type === 'notFound' ? (
        <h2>Plant with id {routeParams.plantId} not found</h2>
      ) : (
        <PlantView
          plantData={routeData}
          isLoading={plantLoading}
          onClose={onClose}
          preventFormClose={setClosePreventedReason}
        />
      )}
    </Modal>
  )
}
